import { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

interface ToastProps {
  id: number;
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: (id: number) => void;
}

export default function Toast({ id, message, type = 'success', onClose }: ToastProps) {
  useEffect(() => {
    if (type === 'error') return;
    const ms = type === 'info' ? 4000 : 2000;
    const t = setTimeout(() => onClose(id), ms);
    return () => clearTimeout(t);
  }, [id, onClose, type]);

  const isError = type === 'error';
  return (
    <div className={`rounded-xl shadow-xl border p-4 mb-3 min-w-[280px] max-w-[380px] animate-slide-in-right ${
      isError
        ? 'bg-red-50/95 border-red-200 dark:bg-red-900/95 dark:border-red-700'
        : 'bg-blue-50/95 border-blue-200 dark:bg-blue-900/95 dark:border-blue-700'
    }`}>
      <div className="flex items-start gap-3">
        <p className={`flex-1 text-sm font-medium ${isError ? 'text-red-900 dark:text-red-100' : 'text-gray-900 dark:text-gray-100'}`}>
          {message}
        </p>
        <button
          onClick={() => onClose(id)}
          className={`p-1 rounded flex-shrink-0 ${
            isError ? 'hover:bg-red-100 dark:hover:bg-red-800/50' : 'hover:bg-blue-100 dark:hover:bg-blue-800/50'
          }`}
          title="Закрыть"
        >
          <FiX className={`w-4 h-4 ${isError ? 'text-red-700 dark:text-red-300' : 'text-slate-500 dark:text-slate-300'}`} />
        </button>
      </div>
    </div>
  );
}
